module.exports = __webpack_public_path__ + "img/articulated_loaders.ddb60f1b.jpg";